import {
    getTplOptions
} from './helper';
import {
    normalIndustry,
    btbIndustry,
    intelSizeOptions,
    promptMatchList,
    industryOptionsByName,
    industryOptionsByNum,
    sortOptions
} from './constants';

const designSizeControlParams = {
    indestryBaseSizeMap: {
        ...btbIndustry.reduce((acc, item) => {
            acc[item] = '1:1';
            return acc;
        }, {}),
        ...normalIndustry.reduce((acc, item) => {
            acc[item] = '16:9';
            return acc;
        }, {})
    },
    sizeControlOptions: function (e) {
        return getTplOptions(e);
    }
};

const templateOptions = {
    titleTypeOptions: [
        {
            value: 'intelForm',
            label: '整图模板'
        }, {
            value: 'designForm',
            label: '组合模板'
        }
    ],
    typeOptions: [
        {
            value: 'templateGroup',
            label: '选择预设'
        }, {
            value: 'systemRandom',
            label: '系统随机'
        }
    ],
    showCultureOption: true,
    industryOptions: industryOptionsByNum,
    sortOptions: sortOptions,
    numberOptions: [
        {
            value: 5,
            label: '5个'
        },
        {
            value: 4,
            label: '4个'
        },
        {
            value: 3,
            label: '3个'
        },
        {
            value: 2,
            label: '2个'
        },
        {
            value: 1,
            label: '1个'
        }
    ],
    ratioOptions: function (e) {
        return getTplOptions(e);
    }
};

// 相同的配置项单独写在前面，给两个模块共用，避免重复
const textGroupConfig = {
    name: 'text',
    label: '文案',
    placeholder: '',
    visible: true,
    type: 'collapse',
    hideTitle: true,
    needClear: ['manufacturerName', 'otherText'],
    params: {
        maxNum: 10,
        randomText: '选择系统随机，将为您在预设文案中随机挑选文案。',
        b2bRandomText: '该行业下暂无预设文案，请手动添加。',
        hideTypeOptions: true,
        titleTip: true,
        titleTipPosition: 'right',
        titleTipTitle: '如何创作文案？',
        titleTipText: '<div class="sec">方式一：通过「AI生成」，智能生成多条文案</div><div class="sec">方式二：通过「推荐文案」筛选合适文案</div>'
            + '<div class="sec">方式三：手动输入文案</div><div style="margin-top: 8px">若填写文案字段个数超出模版包含的文案字段，超出部分不会展示。</div>',
        typeOptions: [
            {
                value: 'textUploadList',
                label: '手动添加'
            },
            {
                value: 'textPreset',
                label: '选择预设'
            },
            {
                value: 'systemRandom',
                label: '系统随机'
            }
        ],
        industryOptions: industryOptionsByName
    },
    sendCustomEvent: {
        textAdd: {
            eventName: '添加文案'
        }
    }
};



export const intelFormConfig = [{
    name: 'template',
    label: '模板',
    placeholder: '',
    visible: true,
    type: 'collapse',
    params: {
        mainComponentName: '',
        chooseMax: 10,
        showIndustrySize: true,
        templateTag: ['擎舵2.0'],
        randomText: '选择系统随机，将为您在模板库中随机挑选合适模板。',
        showNumberSecect: true,
        hideDimensionSelect: false,
        titleTip: true,
        titleTipPosition: 'right',
        titleTipTitle: '如何选择模版？',
        titleTipText: '<div class="sec">1. 根据是/否需要展示抠图人物或产品，选择组合模版/整图模版</div><div class="sec">2. 根据投放场景筛选行业和比例</div>'
            + '<div class="sec">3. 根据业务偏好筛选色系和布局</div>',
        ...templateOptions,
        ...designSizeControlParams
    },
    sendCustomEvent: {
        changeTitleTab: {
            eventName: '选择模板类型'
        }
    },
    rules: [
        {
            required: true,
            validator(rule, value) {
                const chooseList = value.templateGroup.template.chooseList;
                const chooseMyTpl = value.templateGroup.template.chooseMyTpl;
                const type = value.type;
                if (type === 'systemRandom') {
                    return Promise.resolve();
                }
                if (!chooseList?.length && !chooseMyTpl?.length) {
                    return Promise.reject('请选择模板');
                }
                return Promise.resolve();
            }
        }
    ]
}, {
    ...textGroupConfig
}, {
    name: 'background',
    label: '背景图',
    placeholder: '',
    visible: true,
    type: 'collapse',
    canCutout: true,
    params: {
        maxImgNum: 4,
        randomText: '选择系统随机，将为您在预设背景中随机挑选背景图。',
        titleTip: true,
        titleTipPosition: 'right',
        titleTipText: '可自主上传或选择系统推荐背景图。为确保合成效果，请尽量选择与模板背景比例、色系协调的图片，不添加时默认使用模板原背景。',
        typeOptions: [
            {
                value: 'imgUploadList',
                label: '上传图片',
                sendCustomEvent: {
                    imgUpload: {
                        eventName: '上传背景图'
                    }
                }
            }, {
                value: 'bgPreset',
                label: '选择预设',
                sendCustomEvent: {
                    choosePreset: {
                        eventName: '选择预设背景'
                    }
                }
            }
            // , {
            //     value: 'systemRandom',
            //     label: '系统随机'
            // }
        ],
        industryOptions: [],
        ratioOptions: [],
        styleOptions: [],
        colorOptions: []

    }
}, {
    name: 'brandLogo',
    label: '品牌LOGO',
    placeholder: '',
    visible: true,
    type: 'collapse',
    hideTitle: true,
    canCutout: true,
    params: {
        titleTip: true,
        titleTipPosition: 'right',
        titleTipText: '添加后将在模版LOGO对应位置展示品牌LOGO，无LOGO可不添加。'
    },
    sendCustomEvent: {
        imgUpload: {
            eventName: '上传品牌LOGO'
        }
    }
}];

export const designFormConfig = [{
    name: 'template',
    label: '模板',
    placeholder: '',
    visible: true,
    type: 'collapse',
    params: {
        mainComponentName: '',
        chooseMax: 10,
        showIndustrySize: true,
        templateTag: ['组合模板'],
        randomText: '选择系统随机，将为您在模板库中随机挑选合适模板。',
        showNumberSecect: true,
        hideDimensionSelect: false,
        titleTip: true,
        titleTipPosition: 'right',
        titleTipTitle: '如何选择模版？',
        titleTipText: '<div class="sec">1. 根据是/否需要展示抠图人物或产品，选择组合模版/整图模版</div><div class="sec">2. 根据投放场景筛选行业和比例</div>'
            + '<div class="sec">3. 根据业务偏好筛选色系和布局</div>',
        ...templateOptions,
        ...designSizeControlParams
    },
    sendCustomEvent: {
        changeTitleTab: {
            eventName: '选择模板类型'
        }
    },
    rules: [
        {
            required: true,
            validator(rule, value) {
                const chooseList = value.templateGroup.template.chooseList;
                const chooseMyTpl = value.templateGroup.template.chooseMyTpl;
                const type = value.type;
                if (type === 'systemRandom') {
                    return Promise.resolve();
                }
                if (!chooseList?.length && !chooseMyTpl?.length) {
                    return Promise.reject('请选择模板');
                }
                return Promise.resolve();
            }
        }
    ]
}, {
    ...textGroupConfig
}, {
    name: 'mainPart',
    label: '主体',
    placeholder: '',
    visible: true,
    type: 'collapse',
    hideTitle: true,
    canCutout: true,
    params: {
        maxImgNum: 4,
        titleSwitch: true,
        titleSwitchText: '自动抠图',
        titleTip: true,
        titleTipPosition: 'right',
        titleTipText: '可上传图片自动抠图或使用推荐主体形象，不添加时默认使用模版原有主体。',
        typeOptions: [
            {
                value: 'imgUploadList',
                label: '上传图片',
                sendCustomEvent: {
                    imgUpload: {
                        eventName: '上传主体图'
                    }
                }
            },
            // {
            //     value: 'mainPartIntel',
            //     label: '智能生成'
            // },
            {
                value: 'mainPartPreset',
                label: '选择预设背景',
                sendCustomEvent: {
                    choosePreset: {
                        eventName: '选择预设主体'
                    }
                }
            }
        ],
        maxLength: 200,
        showType: false,
        options: intelSizeOptions,
        generatePlaceholder: `请尝试分别描述画面上想要出现的主体
示例：一位三十多岁的中国女性，黑色衣服，马尾辫，韩风，清澈大眼睛，高细节皮肤，微笑，照片般逼真，清晰`,
        promptMatchList,
        industryOptions: [],
        styleOptions: [],
        subjectTypeOptions: []
    },
    rules: [
        {
            required: true,
            validator(rule, value) {
                const type = value.type;
                if (type === 'imgUploadList' && value.imgUploadList?.loading) {
                    return Promise.reject('主体生成中');
                }
                return Promise.resolve();
            }
        }
    ]
}, {
    name: 'background',
    label: '背景图',
    placeholder: '',
    visible: true,
    type: 'collapse',
    canCutout: true,
    params: {
        maxImgNum: 1,
        randomText: '选择系统随机，将为您在预设背景中随机挑选背景图。',
        titleTip: true,
        titleTipPosition: 'right',
        titleTipText: '可自主上传或选择系统推荐背景图。为确保合成效果，请尽量选择与模板背景比例、色系协调的图片，不添加时默认使用模板原背景。',
        typeOptions: [
            {
                value: 'imgUploadList',
                label: '上传图片',
                sendCustomEvent: {
                    imgUpload: {
                        eventName: '上传背景图'
                    }
                }
            }, {
                value: 'bgPreset',
                label: '选择预设',
                sendCustomEvent: {
                    choosePreset: {
                        eventName: '选择预设背景'
                    }
                }
            }, {
                value: 'systemRandom',
                label: '系统随机'
            }
        ],
        industryOptions: [],
        ratioOptions: [],
        styleOptions: [],
        colorOptions: []
    }
}, {
    name: 'brandLogo',
    label: '品牌LOGO',
    placeholder: '',
    visible: true,
    type: 'collapse',
    hideTitle: true,
    canCutout: true,
    params: {
        titleTip: true,
        titleTipPosition: 'right',
        titleTipText: '添加后将在模版LOGO对应位置展示品牌LOGO，无LOGO可不添加。'
    },
    sendCustomEvent: {
        imgUpload: {
            eventName: '上传品牌LOGO'
        }
    }
}];
